import { render, staticRenderFns } from "./CookiesModal.vue?vue&type=template&id=ac85ee9e&"
import script from "./CookiesModal.vue?vue&type=script&lang=js&"
export * from "./CookiesModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiesModal.vue?vue&type=style&index=0&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports